import { FONT_MONO } from '../theme';

/* Circular macro meter for the daily-totals summary. */
export function MacroRing({ t, value, target, color, label, unit }) {
  const size = 66, stroke = 6;
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const ratio = target > 0 ? value / target : 0;
  const over = target > 0 && value > target;
  const col = over ? t.danger : color;
  const offset = circ * (1 - Math.min(1, Math.max(0, ratio)));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
      <div style={{ position: 'relative', width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={t.surfaceAlt} strokeWidth={stroke} />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={col} strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={circ} strokeDashoffset={offset} style={{ transition: 'stroke-dashoffset 0.4s ease' }} />
        </svg>
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: 14, fontFamily: FONT_MONO, fontWeight: 700, color: over ? t.danger : t.text }}>{Math.round(value)}</span>
        </div>
      </div>
      <div style={{ textAlign: 'center', lineHeight: 1.2 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: t.textFaint, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{label}</div>
        <div style={{ fontSize: 10, color: t.textMuted, fontFamily: FONT_MONO }}>/ {target || 0}{unit === 'g' ? 'g' : ''}</div>
      </div>
    </div>
  );
}
